
module.exports = {

  CHECKBOX_STATE: {
    CHECKED: 1,
    UNCHECKED: 2,
    UNDETERMINED: 3
  }

}
